import { findValeValido, findValesPresentesByVendaId } from "@/api/valepresente"
import { ValePresenteServiceAdapter } from "@/usecases/valepresente/adapter"
import { injectable } from "inversify"

@injectable()
export class ValePresenteService implements ValePresenteServiceAdapter{
	findValeValido = async (id: string, grupoEconomicoId: string) => await findValeValido(id, grupoEconomicoId)	
	findValesPresentesByVendaId = async (vendaId: string) => await findValesPresentesByVendaId(vendaId)	
}